export const exterior_view04ImageOptions = {
  angle: 'exterior_view04',
  staticOptions: {
    BowSpirit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'Deck',
      dependency: null
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'Sprayhood',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC45/views/exterior_view04.js